import script from "./DatasetDependencies.vue?vue&type=script&setup=true&lang=ts"
export * from "./DatasetDependencies.vue?vue&type=script&setup=true&lang=ts"

import "./DatasetDependencies.vue?vue&type=style&index=0&id=c40e1678&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c40e1678"]])

export default __exports__